import axiosInstance from '../../../axiosInstance'
import apiEndpoints from '../../../api'


export const getInvoiceTypesReq = (action) => {
    const searchQuery = action?.data || {};
    const params = {
        page: searchQuery.page || 1,
        limit: searchQuery.limit || 10,
    };

    // Only include invoice_type if it has a valid value
    if (searchQuery.invoice_type) {
        params.invoice_type = searchQuery.invoice_type;
    }

    // Include society_id if provided
    if (searchQuery.society_id) {
        params.society_id = searchQuery.society_id;
    }

    return axiosInstance.get(apiEndpoints.GET_INVOICE_TYPES_API, { params });
}

export const getInvoiceTypeDetailsReq = (action) => {
    const invoiceTypeId = action?.data?.id || ''
    const url = apiEndpoints.GET_INVOICE_TYPE_DETAILS_API.replace(':id', invoiceTypeId)
    return axiosInstance.get(url);
}

export const createInvoiceTypeReq = (action) => {
    const payload = action?.data || {}
    return axiosInstance.post(apiEndpoints.CREATE_INVOICE_TYPE_API, payload);
}

export const updateInvoiceTypeReq = (action) => {
    const invoiceTypeId = action?.data?.id || ''
    let payload = { ...action?.data } || {}
    delete payload.id;
    delete payload.onSuccess;
    const url = apiEndpoints.UPDATE_INVOICE_TYPE_API.replace(':id', invoiceTypeId)
    return axiosInstance.put(url, payload);
}

export const deleteInvoiceTypeReq = (action) => {
    const invoiceTypeId = action?.data?.id || ''
    const societyId = action?.data?.society_id
    const url = apiEndpoints.DELETE_INVOICE_TYPE_API.replace(':id', invoiceTypeId)
    const params = societyId ? { society_id: societyId } : {}
    return axiosInstance.delete(url, { params });
}
